.vs-modal-container .vs-modal-content{
  min-height: 200px;
}
